import { __decorate } from "tslib";
import Component from 'vue-class-component';
import CrudComponent from '@/classes/CrudComponent';
import { Watch } from "vue-property-decorator";
let Notifications = class Notifications extends CrudComponent {
    get unreadNotifications() {
        return this.$store.getters['notification/unread'](this.$store.getters['user/userId']);
    }
    get notifications() {
        return this.$store.getters['notification/all'](this.$store.getters['user/userId']);
    }
    readNotification(item) {
        if (item.data.readAt === null) {
            this.$store.dispatch('notification/read', item);
        }
        if (item.data.link) {
            if (this.$route.name === item.data.link.name) {
                let equal = true;
                if (item.data.link.params) {
                    for (const key of (Object.keys(this.$route.params))) {
                        if (!item.data.link.params[key] || this.$route.params[key] !== item.data.link.params[key]) {
                            equal = false;
                            break;
                        }
                    }
                    for (const key of (Object.keys(item.data.link.params))) {
                        if (!this.$route.params[key] || this.$route.params[key] !== item.data.link.params[key]) {
                            equal = false;
                            break;
                        }
                    }
                }
                if (Object.keys(this.$route.params).length === 0) {
                    equal = false;
                }
                if (equal) {
                    return;
                }
            }
            this.$router.push(item.data.link);
        }
    }
    deleteNotification(item) {
        this.$store.dispatch('notification/destroy', item);
    }
    readAllNotifications() {
        this.$store.dispatch('notification/readBatch', this.unreadNotifications);
    }
    deleteAllNotifications() {
        this.$store.dispatch('notification/destroyBatch', this.notifications);
    }
    shakeBell() {
        const bell = document.querySelector('#notification-bell');
        if (!bell) {
            return;
        }
        bell.classList.toggle('shake');
        setTimeout(() => {
            bell.classList.toggle('shake');
        }, 1000);
    }
    onNotificationsUpdate(current, old) {
        if (old.length < current.length) {
            this.shakeBell();
        }
    }
};
__decorate([
    Watch('unreadNotifications')
], Notifications.prototype, "onNotificationsUpdate", null);
Notifications = __decorate([
    Component
], Notifications);
export default Notifications;
